export const aboutData = {
    title: "Know Me",
    description1: "My name is Shohas. I'm a web designer and developer based in Dhaka, Bangladesh.",
    description2: "I am a self-motivated IT expert with extensive experience and understanding in ReactJS, NodeJS, ExpressJS, and mobile responsive web development, as well as strong talents and abilities in developing clean and efficient code Web Skills.",
    image: 1
}